import React from 'react';
import { inject, observer } from 'mobx-react';

import '../../styles/components/EmployeeBar.css';
import Employee from './Employee';

export default inject('employeeStore', 'dayStore')(
  observer(class EmployeeBar extends React.Component {
    employeeItem(employee) {
      let availabilityMeter = null;
      let leaveIndicator = null;

      if (this.props.dayStore.activeDay && employee.availability !== undefined) {
        availabilityMeter = (
          <div className="employeebar__item-availability">
            <div style={{ width: `${employee.availability * 100}%` }}></div>
          </div>
        );
      }

      if (this.props.dayStore.activeDay && employee.on_leave) {
        leaveIndicator = (
          <span className="employeebar__item-leave">(Afwezig)</span>
        );
      }

      return (
        <Employee
          key={employee.id}
          employee={employee}
          leaveIndicator={leaveIndicator}
          availabilityMeter={availabilityMeter}
        />
      );
    }

    render() {
      const { employeeStore } = this.props;

      let employees = null;

      if (typeof employeeStore.employees !== 'undefined' && employeeStore.employees.length) {
        employees = employeeStore.employees.map(this.employeeItem.bind(this));
      }

      return (
        <div className='employeebar'>
          {employees}
        </div>
      );
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/EmployeeBar/index.js